import { createBlobURL } from "../../dom/index.js";
import { getBlockProps } from "../blocks-parser/index.js";
import { every } from "lodash";

const videoFileSchema = {
  blockSlug: "grigora/video",
  isMatch(files) {
    // The following check is intended to catch non-image files when dropped together with images.
    return files.length === 1 && files[0].type.indexOf("video/") === 0;
  },
  transform(files) {
    const file = files[0];
    const block = {
      blockSlug: "grigora/video",
      blockProps: {
        srcMode: "link",
        src: createBlobURL(file),
        srcActionTrigger: "upload",
      },
    };
    return block;
  },
};

export { videoFileSchema };
